import React, { useState } from 'react';

import { DocumentApi, NotificationManager } from '@atlas/core';
import { Button, HeaderTitle, Label } from '@atlas/ui';

const FinancialReport = () => {
  const [loading, setLoading] = useState(false);

  const downloadPdf = async () => {
    setLoading(true);

    try {
      const { blob, fileName } = await DocumentApi.getClientIncomeSummary();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = blobUrl;
      link.download = fileName || 'summary.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);

      NotificationManager.notify({
        message: 'financial_report_download_success',
        status: 'success',
        type: 'notification',
      });
    } catch {
      NotificationManager.notify({
        message: 'financial_report_download_error',
        status: 'error',
        type: 'notification',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-financial-report">
      <div className="title-wrapper border">
        <HeaderTitle title="financial_report_download" />
      </div>

      <div className="profile-financial-report-container">
        <Label
          className="profile-financial-report__text description title-small-300-text"
          message="financial_report_important_info"
        />
        <Button
          className="report-download"
          disabled={loading}
          icon="download"
          loading={loading}
          onClick={downloadPdf}
          size="big"
        >
          <Label message="download" />
        </Button>
      </div>
    </div>
  );
};

export default FinancialReport;
